import { render, staticRenderFns } from "./SelectItemSmall.vue?vue&type=template&id=b244526e&"
import script from "./SelectItemSmall.vue?vue&type=script&lang=js&"
export * from "./SelectItemSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports